import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Breadcrumb from 'src/components/Breadcrumb';

const Toolbar = ({ className, ...rest }) => {
  const { t } = useTranslation();

  return (
    <div {...rest}>
      <Breadcrumb doNotRedirectIndexList={[0]} />
      <Box>
        <Typography
          sx={{ fontWeight: '400', textTransform: 'capitalize' }}
          color="primary"
          variant="h1"
        >
          {t('BUREAU_REPORTS.TITLE')}
        </Typography>
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
